import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logistica',
  templateUrl: './logistica.component.html',
  styles: []
})
export class LogisticaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
